import { useState, useCallback } from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiesPage from "@/pages/CookiesPage";
import TermsPage from "@/pages/TermsPage";
import ThankYouPage from "@/pages/ThankYouPage";
import CookieBanner from "@/components/CookieBanner";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "@/i18n";

function LangGate({ children }) {
  const { lang } = useParams();
  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }
  return children;
}

function App() {
  const [openSignal, setOpenSignal] = useState(0);
  const openCookies = useCallback(() => setOpenSignal((v) => v + 1), []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Root -> default language */}
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />

          {/* Spanish-only thank_you page (outside lang tree) */}
          <Route path="/thank_you" element={<ThankYouPage />} />

          {/* Language-scoped routes */}
          <Route
            path="/:lang"
            element={
              <LangGate>
                <Layout onOpenCookies={openCookies}>
                  <HomePage />
                </Layout>
              </LangGate>
            }
          />
          <Route
            path="/:lang/privacy"
            element={
              <LangGate>
                <Layout onOpenCookies={openCookies}>
                  <PrivacyPage />
                </Layout>
              </LangGate>
            }
          />
          <Route
            path="/:lang/cookies"
            element={
              <LangGate>
                <Layout onOpenCookies={openCookies}>
                  <CookiesPage />
                </Layout>
              </LangGate>
            }
          />
          <Route
            path="/:lang/terms"
            element={
              <LangGate>
                <Layout onOpenCookies={openCookies}>
                  <TermsPage />
                </Layout>
              </LangGate>
            }
          />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        </Routes>
        <CookieBanner openSignal={openSignal} />
      </BrowserRouter>
    </div>
  );
}

export default App;
